export default __webpack_public_path__ + "c36e44d1c9cbb24c9cf74c3e0a7d8e0b.svg";